import React from 'react';
import { Button } from 'antd';
import classnames from 'classnames';

import styles from '../cms.module.scss';

export const Document = ({ value: { document: { url, title = url } }, level, align }) => (
  <div
    className={classnames(
      styles.cms__button,
      styles[`cms__button--${align}`],
    )}
  >
    <Button type={level} href={url} download>{title}</Button>
  </div>
);

export default Document;



// WEBPACK FOOTER //
// ./src/modules/CMS/components/Document/index.js